<div>
    <mat-dialog-content class="account-box"
        style="overflow: hidden; scroll-behavior: unset;">
        <img src="assets/img/close-black-icon.svg" alt
            class="close-icon cursor-pointer" 
            (click)="closeDialog()" />
        <div class="text-center">

            <div class="REF-invite-img-holder mt-2">
                <img src="assets/img/invite-earn.svg" alt class="REF-invite-img" />
            </div>
            <h3 class="REF-heading-title mt-5">Enjoying Infinity
                Learn?</h3>
            <p class="REF-sub-title mt-3">Now you can refer your friends and
                earn exciting rewards!</p>
            <div class="REF-copy-wrpmain">
                <button class="REF-copy-linkbtn" (click)="copyRefCode()">
                    <img src="assets/img/CYOT-copy-blue.svg" alt
                        class="REF-copyimg-btn" />
                    Copy Referral Link
                </button>
                <button class="REF-sh-socimg-h" mat-fab
                     shareButton="whatsapp" [url]="this.referralObj?.deepLink"
                    (click)="sendModeOfShare('whatsapp')" >
                    <div class="REF-sh-icon-outer">
                        <i class="fab fa-whatsapp REF-sh-whatsapp-ic" ></i>
                    </div>
                </button>
                <button (click)="shareSocialdialog()" class="REF-share-ic"><img
                        src="assets/img/CYOT-share-blueicon.svg" alt /></button>

            </div>
        </div>
    </mat-dialog-content>
</div>